import { BlockTitle } from "@blocks/Blocks";
import Listing from "@particles/listing/Listing";
import { useSendInViewGTM } from "@routes/SingaporeGe/2025/hooks/useSendInViewGTM";
import { GE2025_PAGE_SIZE } from "@routes/SingaporeGe/2025/utils/constants";
import { RelatedStoriesProps } from "@routes/SingaporeGe/2025/utils/types";

/**
 * RelatedStories component to display the related stories section for singapore ge pages.
 * Figma: https://www.figma.com/design/EUTUYjBn7HHbsLRjqK4t5h/GE-2025--WEB---APP-?node-id=11034-4582&t=4NXCtXdS4g1R5hiL-4
 */
const RelatedStories = ({
  className,
  cardProps,
  gaObject,
  entity,
}: RelatedStoriesProps): React.ReactElement => {
  const { ref: relatedStoriesRef } = useSendInViewGTM({
    eventsObject: gaObject?.eventObject,
  });

  return (
    <div
      data-testid={"ge-2025-related-stories"}
      ref={relatedStoriesRef}
      className={className}
    >
      <BlockTitle text="LATEST GE2025 NEWS" />

      <Listing
        cardProps={cardProps}
        urlPath={entity.tag.urlPath}
        size={GE2025_PAGE_SIZE}
        pageType={"keyword"}
      />
    </div>
  );
};

export default RelatedStories;
